<template>
  <PageHeader title="Promotions">
    <CreateButton @click="openModal = true">Ajouter une promotion</CreateButton>
  </PageHeader>

  <Modal :open="openModal" @close="openModal = false">
    <DiscountForm @discountCreated="handleDiscountCreated" />
  </Modal>

  <Table :columns="columns" :data="discounts">
    <template #enabled="{ row }">
      <div
        class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
        :class="row.enabled ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
      >
        {{ row.enabled ? "Oui" : "Non" }}
      </div>
    </template>
    <template #discountType="{ row }">
      <div
        class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
        :class="row.discountType === 'discount' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'"
      >
        {{ row.discountType === "discount" ? "Mois à prix réduit" : "Mois offert" }}
      </div>
    </template>
  </Table>
</template>

<script>
import { CreateButton, PageHeader, Table, Modal } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";
import DiscountForm from "@/components/discount/DiscountForm.vue";

export default {
  components: {
    CreateButton,
    PageHeader,
    Table,
    Modal,
    DiscountForm,
  },

  data() {
    return {
      openModal: false,
      columns: [
        {
          label: "Titre",
          field: "title",
          bold: true,
        },
        {
          label: "Type",
          field: "discountType",
          slot: "discountType",
        },
        {
          label: "Code",
          field: "code",
        },
        {
          label: "Nombre de mois",
          field: "offeredMonths",
          numeric: true,
        },
        {
          label: "Activé",
          field: "enabled",
          slot: "enabled",
        },
      ],
    };
  },

  computed: {
    ...mapGetters("discounts", { discounts: "getIndex" }),
  },

  async mounted() {
    await this.fetchIndex({ enabled: true });
  },

  methods: {
    ...mapActions("discounts", ["fetchIndex"]),

    handleDiscountCreated() {
      this.openModal = false;
      this.fetchIndex({ enabled: true });
    },
  },
};
</script>
